import React, { useState, useEffect } from "react";
import AuditeeInfo from "../../icons/auditeeInfo.svg?react";
import AuditTheme from "../../icons/Audit Theme.svg?react";
import config from "../../icons/config.svg?react";
import Review from "../../icons/review.svg?react";
import Users from "../../icons/users.svg?react";
import { parseDate, loadOrganizationLogos } from "../../utils";
import { AuditOption } from "../../commonTypes";
import "../../Containers/CreateAuditPlanning/style.scss";
import Step3 from "../../Components/Steps/Step3AuditorTeam";
import Step2 from "../../Components/Steps/Step2AuditTheme";
import Step4 from "../../Components/Steps/Step4AuditPreference";
import Step5 from "../../Components/Steps/Step5ReviewandSubmit";
import CreateAudit from "../../Components/Steps/CreateAudit";
import Step1 from "../../Components/Steps/step1AuditeeOrganization";
import { setMappedBanksvalues } from "../../reducers/bankSlice";
import { useDispatch } from "react-redux";
import {
  setSelectedMembers,
  setSelectedThemes,
  setSequenceSteps,
} from "../../reducers/Audit";
interface TeamMember {
  id: string;
  name: string;
  email: string;
}

interface AuditeMember {
  email: string;
  name: string;
  memberId: string;
  role: string;
}
interface Teamlead {
  email: string;
  name: string;
  memberId: string;
  role: string;
}
interface OrganizationDetail {
  organizationId: number;
  name: string;
  type: string;
  applicationName: string;
  organizationEmail: string;
  teamLead: Teamlead[];
  members: AuditeMember[];
  logo?: string;
  createdBy?: string | null;
  createdDate?: Date | null;
  mappedAt?: Date;
  modifiedBy?: string | null;
  modifiedDate?: Date | null;
}
export interface UpdateData {
  teamMembers: TeamMember[];
  auditLevel: number;
  auditType: number;
  auditSla: number;
  escalationDay: number;
  kickOffMeeting: boolean;
  auditeeInfo: {
    membersname?: string[];
    membersmail?: string[];
    applicationName?: string[];
    auditThemeNames?: string[];
    sequencedata?: any[];
    organizationdetail?: OrganizationDetail[];
    organizationDetailsData?: {
      orgId: number;
      applicationId: number[];
      auditeeMembers: { memberId: number; role: string }[];
      auditeeTeamLead: { memberId: number; role: string }[];
    }[];
    members: TeamMember[];
    applicationID: number[];
    startDate: Date;
    startDateMarker: Date;
    endDate: Date;
    endDateMarker: Date;
    auditee: string;
    emails: AuditeMember[];
    organizations: AuditeMember[];
    auditThemes: AuditeMember[];
    auditScope: string;
    applicationDesc: string;
    auditeeTeamLead: Teamlead[];
    isTeamLead?: boolean;
  };
}
interface StateProps {
  userData: any;
  membersList: any;
  auditTypeList: any;
  auditeesList: any;
  teamleadList: any;
  auditUpdatedata: any;
  getTheme: any;
  sequence: any;
  getOrganization: any;
  loading: boolean;
  showToast: boolean;
  onSubmit: (data: UpdateData) => void;
}

const UpdateAuditPlanning: React.FC<StateProps> = ({
  userData,
  membersList,
  loading,
  showToast,
  auditeesList,
  getOrganization,
  getTheme,
  auditUpdatedata,
  sequence,
  onSubmit,
}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [teamMembersDisplay, setTeamMembersDisplay] = useState<string[]>();
  const [auditeeDisplay, setAuditeeDisplay] = useState<string>("");
  const [showAIobservation, setShowAIobservation] = useState(false);
  const [showAItooltip, setShowAItooltip] = useState(false);
  const [showAISuggestion, setShowAISuggestion] = useState(false);
  const [AIloading, setAIloading] = useState(false);
  const [showAICompanion, setShowAICompanion] = useState(false);
  const [aiSuggestion, setaiSuggestion] = useState<any[]>([]);
  const [aiContextHistory, setAiContextHistory] = useState<
    { contextName: string; payload: any }[]
  >([]);
  const dispatch = useDispatch();
  const [auditData, setAuditData] = useState<UpdateData>({
    teamMembers: [],
    auditLevel: 1,
    auditType: 0,
    auditSla: 0,
    escalationDay: 0,
    kickOffMeeting: false,
    auditeeInfo: {
      applicationID: [],
      members: [],
      sequencedata: [],
      organizations: [],
      auditThemes: [],
      auditeeTeamLead: [],
      startDate: new Date(),
      startDateMarker: new Date(),
      endDate: new Date(),
      endDateMarker: new Date(),
      auditee: "",
      emails: [],
      auditScope: "",
      applicationDesc: "",
    },
  });
  const [auditMembers, setAuditMembers] = useState<any>([]);
  const [selectedMembersOption, setSelectedMembersOption] = useState<any>([]);
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const [validated, setValidated] = useState(false);
  const [submitClicked, setSubmitClicked] = useState(false);
  const [checked, setChecked] = useState(false);
  const [sequenceMode, setSequenceMode] = useState<"default" | "custom">(
    "default",
  );
  const [customSequenceOrder, setCustomSequenceOrder] = useState<any[]>(
    sequence || [],
  );

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.checked;
    setChecked(value);
    setAuditData((prev) => ({
      ...prev,
      kickOffMeeting: value,
    }));
  };
  const steps = [
    { number: 1, title: "Auditee Organization", icon: Users },
    { number: 2, title: "Audit Theme", icon: AuditTheme },
    { number: 3, title: "Auditor Team", icon: AuditeeInfo },
    { number: 4, title: "Audit Preference", icon: config },
    { number: 5, title: "Review and Submit", icon: Review },
  ];

  const loadAuditFormData = (data: any): UpdateData => {
    return {
      auditType: data.auditTypeId ?? 0,
      escalationDay: data.escalationFrequency ?? 0,
      auditLevel: data.auditLevel ?? 1,
      auditSla: data.responseTime ?? 0,
      kickOffMeeting: data.kickOffMeeting ?? false,
      teamMembers:
        data.auditorMembers?.map((member: { id: number }) => member.id) ?? [],

      auditeeInfo: {
        auditee: data.auditingId ?? 0,
        emails: data.auditeeMembers?.map((m: any) => m.email) ?? [],
        sequencedata:
          data.auditSequences
            ?.sort((a: any, b: any) => a.sequenceOrderId - b.sequenceOrderId)
            ?.flatMap((item: any) =>
              (item.sequence || []).map((seq: any) => ({
                sequenceId: seq.sequenceId,
                sequenceName: seq.sequenceName,
                sequenceOrder: item.sequenceOrderId,
                questionValidationRequired:
                  item.questionValidationRequired || false,
                responseValidationRequired:
                  item.responseValidationRequired || false,
              })),
            ) ?? [],
        auditThemes: data.auditTheme?.map((t: any) => t.themeCode) ?? [],
        members: data.auditeeMembers ?? [],
        membersname: data.auditeeMembers?.map((m: any) => m.name) ?? [],
        membersmail: data.auditeeMembers?.map((m: any) => m.email) ?? [],
        auditeeTeamLead: data.auditeeTeamLead ?? [],

        organizations:
          data.organizations?.map((org: any) => ({
            organizationId: org.organizationId,
            organizationName: org.organizationName,
            organizationEmail: org.organizationEmail,
          })) ?? [],

        applicationID:
          data.applications?.map((app: any) => app.applicationId) ?? [],
        applicationName:
          data.applications?.map((app: any) => app.applicationName) ?? [],
        auditThemeNames: data.auditTheme?.map((t: any) => t.themeName) ?? [],
        auditScope: data.scope ?? "",
        applicationDesc: data.applicationDesc ?? "",
        startDateMarker: new Date(data.startDate),
        startDate: new Date(data.startDate),
        endDateMarker: new Date(data.endDate),
        endDate: new Date(data.endDate),
      },
    };
  };
  useEffect(() => {
    const processOrganizationsWithLogos = async () => {
      if (auditUpdatedata) {
        const formatedAuditUpdatedata = loadAuditFormData(auditUpdatedata);
        setAuditData(formatedAuditUpdatedata);
        setChecked(formatedAuditUpdatedata?.kickOffMeeting);

        // Initialize Redux sequenceSteps with the loaded sequence data for edit mode
        if (formatedAuditUpdatedata.auditeeInfo.sequencedata) {
          dispatch(
            setSequenceSteps(formatedAuditUpdatedata.auditeeInfo.sequencedata),
          );
        }

        // Load and convert organization logos
        const organizations = auditUpdatedata?.organizations || [];
        console.log(organizations);
        const logoMap =
          organizations.length > 0
            ? await loadOrganizationLogos(organizations)
            : new Map();

        const orgs =
          organizations.map((org: any, idx: number) => {
            const convertedLogo =
              logoMap.get(org.organizationId) || org.organizationLogo;
            return {
              organizationId: org.organizationId,
              name: org.organizationName,
              logo: convertedLogo,
              organizationLogo: convertedLogo,
              organizationEmail: org.organizationEmail,
              type: org.industryOrSector,
              applicationId:
                org.applications?.map((app: any) => app.applicationId) ?? [],
              applicationName:
                org.applications?.map((app: any) => app.applicationName) ?? [],
              members: (org.auditeeMembers || []).map((m: any) => ({
                memberId: m.id,
                name: m.name,
                email: m.email,
                role: "Member",
              })),
              teamLead: (org.auditeeTeamLead || []).map((m: any) => ({
                memberId: m.id,
                name: m.name,
                email: m.email,
                role: "Lead",
              })),
            };
          }) ?? [];
        dispatch(setMappedBanksvalues(orgs));
        updateAuditeeInfo("organizations", orgs);
      }
    };

    processOrganizationsWithLogos();
  }, [auditUpdatedata]);
  const updateAuditeeInfo = (
    field: keyof UpdateData["auditeeInfo"],
    value: any,
  ) => {
    if (field === "organizations" && Array.isArray(value)) {
      const formattedAuditeeInfo = value.map((item: any) => ({
        orgId: item.organizationId,
        applicationId: item.applicationId || [],
        auditeeMembers: (item.members || []).map((m: any) => ({
          memberId: m.memberId,
          role: "Member",
        })),
        auditeeTeamLead: (item.teamLead || []).map((m: any) => ({
          memberId: m.memberId,
          role: "Lead",
        })),
      }));
      setAuditData((prev) => ({
        ...prev,
        auditeeInfo: {
          ...prev.auditeeInfo,
          organizations: value.map((item: any) => item.organizationId),
          auditeeTeamLead: value.map((item: any) => item.teamLead),
          emails: value.map((item: any) => item.members),
          applicationID: value.map((item: any) => item.applicationId),
          applicationName: value.map((item: any) => item.name),
          applicationType: value.map((item: any) => item.type),
          organizationdetail: value,
          organizationDetailsData: formattedAuditeeInfo,
        },
      }));
      return;
    }
    if (field === "sequencedata") {
      // Check if value already has the full payload structure (from Step2AuditTheme)
      const isFullPayload =
        value.length > 0 &&
        Object.prototype.hasOwnProperty.call(value[0], "questionValidationRequired") &&
        Object.prototype.hasOwnProperty.call(value[0], "responseValidationRequired");

      if (isFullPayload) {
        // Value is already in the correct format from Step2AuditTheme
        setAuditData((prev) => ({
          ...prev,
          auditeeInfo: {
            ...prev.auditeeInfo,
            sequencedata: value,
          },
        }));
      } else {
        // Legacy format: transform it
        setCustomSequenceOrder(value);
        const result = value.map((item: any, index: any) => ({
          sequenceId: item.sequenceId || item.id,
          sequenceOrder: index + 1,
        }));
        setAuditData((prev) => ({
          ...prev,
          auditeeInfo: {
            ...prev.auditeeInfo,
            sequencedata: result,
          },
        }));
      }
      return;
    }
    if (field === "auditThemes" && Array.isArray(value)) {
      setAuditData((prev) => ({
        ...prev,
        auditeeInfo: {
          ...prev.auditeeInfo,
          auditThemes: value.map((item: any) => item.themeId),
          auditThemeNames: value.map((item: any) => item.themeName),
        },
      }));
      return;
    }
    if (field === "members" && Array.isArray(value)) {
      setAuditData((prev) => ({
        ...prev,
        auditeeInfo: {
          ...prev.auditeeInfo,
          members: value.map((item: any) => item.value),
          membersname: value.map((item: any) => item.label),
          membersmail: value.map((item: any) => item.email),
        },
      }));
      return;
    }
    setAuditData((prev) => ({
      ...prev,
      auditeeInfo: { ...prev.auditeeInfo, [field]: value },
    }));
  };

  const validateStep1 = () => {
    const orgDetails = auditData.auditeeInfo.organizationdetail;
    if (!orgDetails || orgDetails.length === 0) return false;

    for (const org of orgDetails) {
      if (!org.organizationId || !org.name || !org.type) return false;
      if (!org.members || org.members.length === 0) return false;
    }

    return true;
  };

  const validateStep2 = () => {
    const { auditeeInfo } = auditData;
    const errors: Record<string, string> = {};

    const themeNames = (auditeeInfo as any).auditThemeNames;

    // 1️⃣ Validate that at least one theme is selected
    if (!auditeeInfo.auditThemes || auditeeInfo.auditThemes.length === 0) {
      errors.auditThemes = "Please select at least one audit theme.";
    }

    // 2️⃣ Validate theme name mapping count
    if (themeNames && themeNames.length !== auditeeInfo.auditThemes.length) {
      errors.auditThemeNames = "Mismatch between selected theme IDs and names.";
    }

    // 3️⃣ Validate that theme names are not empty
    if (themeNames && themeNames.some((name: string) => !name.trim())) {
      errors.auditThemeNames = "Theme names cannot be empty.";
    }

    // 4️⃣ Return result
    if (Object.keys(errors).length > 0) {
      console.error("Step 2 validation failed:", errors);
      return false;
    }

    return true;
  };

  const validateStep3 = () => {
    const { auditeeInfo } = auditData;
    const errors: Record<string, string> = {};

    const members = auditeeInfo.members || [];
    const memberNames = (auditeeInfo as any).membersname || [];
    const memberMails = (auditeeInfo as any).membersmail || [];

    // 1️⃣ Check that at least one member is selected
    if (members.length === 0) {
      errors.members = "Please select at least one auditee member.";
    }

    // 2️⃣ Check that all arrays have matching counts
    if (
      members.length !== memberNames.length ||
      members.length !== memberMails.length
    ) {
      errors.members = "Mismatch between member IDs, names, or emails.";
    }

    // 3️⃣ Check for empty or invalid values
    if (memberNames.some((name: string) => !name.trim())) {
      errors.membersname = "Member names cannot be empty.";
    }

    // 4️⃣ Return result
    if (Object.keys(errors).length > 0) {
      console.error("Step 3 validation failed:", errors);
      return false;
    }

    return true;
  };

  const validateStep4 = () => {
    if (
      auditData.auditeeInfo.startDate.getTime() ===
      auditData.auditeeInfo.startDateMarker.getTime()
    )
      return false;
    if (
      auditData.auditeeInfo.endDate.getTime() ===
      auditData.auditeeInfo.endDateMarker.getTime()
    )
      return false;
    if (auditData.auditLevel === 0) return false;
    if (auditData.auditSla === 0) return false;
    return true;
  };
  const nextDisable =
    (currentStep === 1 && !validateStep1()) ||
    (currentStep === 2 && !validateStep2()) ||
    (currentStep === 3 && !validateStep3());

  const nextStep = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    let isValid = true;

    switch (currentStep) {
      case 1:
        isValid = validateStep1();
        break;
      case 2:
        isValid = validateStep2();
        break;
      case 3:
        isValid = validateStep3();
        break;
      case 4:
        isValid = true;
        break;
      default:
        isValid = true;
        break;
    }

    if (!isValid) {
      setValidated(true);
      return;
    }
    setValidated(false);
    if (currentStep < 5) setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const handleSubmit = () => {
    dispatch(setSelectedThemes([]));
    dispatch(setSelectedMembers([]));
    dispatch(setMappedBanksvalues([]));
    onSubmit(auditData);
    setSubmitClicked(true);
  };
  const handleChangeMembers = (selectValue: any[]) => {
    setAuditMembers(selectValue);
    const memberSet: string[] = [];
    const memberOptions: AuditOption[] = [];
    membersList.map((res: AuditOption) => {
      if (selectValue.includes(res.value as never)) {
        memberSet.push(res.label);
        memberOptions.push(res);
      }
    });
    setTeamMembersDisplay(memberSet);
    setSelectedMembersOption(memberOptions);
    setAuditData((prev) => ({
      ...prev,
      teamMembers: selectValue,
    }));
  };
  const onMembersChange = (selectValue: any[]) => {
    setAuditMembers(selectValue?.map((data) => data?.value));
    const memberSet: string[] = [];
    const memberOptions: AuditOption[] = [];
    selectValue.forEach((res: AuditOption) => {
      memberSet.push(res.label);
      memberOptions.push(res);
    });
    setTeamMembersDisplay(memberSet);
    setSelectedMembersOption(memberOptions);
    setAuditData((prev) => ({
      ...prev,
      teamMembers: selectValue,
    }));
  };

  interface StatusDotProps {
    color: string; // Accepts any valid CSS color value
    size?: number; // Optional size prop (default: 10px)
  }
  const statusColorMap: Record<string, string> = {
    Shallow: "green",
    Descriptive: "#a6b92b",
    Moderate: "#fec107",
    Deeper: "#f8811e",
    Deepest: "red",
  };
  const StatusDot: React.FC<StatusDotProps> = ({ color, size = 10 }) => {
    return (
      <div
        style={{
          width: `${size}px`,
          height: `${size}px`,
          backgroundColor: color,
          borderRadius: "50%",
          display: "inline-block",
          marginBottom: "-2px",
        }}
      />
    );
  };

  const onDateChange = (startDate: any, endDate: any) => {
    const convertedStartDate = parseDate(startDate); // "01-07-2025"
    const convertedEndDate = parseDate(endDate);
    setAuditData((prev) => ({
      ...prev,
      auditeeInfo: {
        ...prev.auditeeInfo,
        startDate: convertedStartDate,
        endDate: convertedEndDate,
      },
    }));
  };

  const isInValidDuration =
    auditData.auditeeInfo.startDate?.getTime() ===
    auditData.auditeeInfo.startDateMarker?.getTime() ||
    auditData.auditeeInfo.endDate.getTime() ===
    auditData.auditeeInfo.endDateMarker.getTime();

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <Step1
            banks={getOrganization}
            updateAuditeeInfo={updateAuditeeInfo}
            setShowAICompanion={setShowAICompanion}
            showAICompanion={showAICompanion}
          />
        );

      case 2:
        return (
          <Step2
            auditUpdatedata={auditUpdatedata}
            sourceItems={getTheme}
            destinationItems={getTheme.length}
            auditeesList={auditeesList}
            updateAuditeeInfo={updateAuditeeInfo}
            auditData={auditData}
            setShowAICompanion={setShowAICompanion}
            showAICompanion={showAICompanion}
            sequence={
              customSequenceOrder.length > 0 ? customSequenceOrder : sequence
            }
          />
        );

      case 3:
        return (
          <Step3
            auditUpdatedata={auditUpdatedata}
            updateAuditeeInfo={updateAuditeeInfo}
            destinationItems={membersList.length}
            auditMembers={auditMembers}
            membersList={membersList}
            selectedMembersOption={selectedMembersOption}
            validated={validated}
            userData={userData}
            auditData={auditData}
            setAuditData={setAuditData}
            handleChangeMembers={handleChangeMembers}
            onMembersChange={onMembersChange}
            setShowAICompanion={setShowAICompanion}
            showAICompanion={showAICompanion}
          />
        );

      case 4:
        return (
          <Step4
            checked={checked}
            handleToggle={handleToggle}
            updateAuditeeInfo={updateAuditeeInfo}
            isInValidDuration={isInValidDuration}
            onDateChange={onDateChange}
            auditUpdatedata={auditUpdatedata}
            handleDatechangeAPICall={() => { /* noop */ }}
            key={showAISuggestion ? "step3-mounted" : "step3-unmounted"}
            validated={validated}
            setAuditData={setAuditData}
            auditData={auditData}
            setShowAISuggestion={setShowAISuggestion}
            aiSuggestion={aiSuggestion}
            showAISuggestion={showAISuggestion}
            AIloading={AIloading}
            setShowAICompanion={setShowAICompanion}
            showAICompanion={showAICompanion}
            handleTimeoutcall={() => { /* noop */ }}
            handleRemainderCall={() => { /* noop */ }}
            sequence={
              customSequenceOrder.length > 0 ? customSequenceOrder : sequence
            }
            sequenceMode={sequenceMode}
            setSequenceMode={setSequenceMode}
          />
        );
      case 5:
        return (
          <Step5
            statusColorMap={statusColorMap}
            auditData={auditData}
            teamMembersDisplay={teamMembersDisplay}
            auditeeDisplay={auditeeDisplay}
            StatusDot={StatusDot}
            userData={userData}
            sequence={
              customSequenceOrder.length > 0 ? customSequenceOrder : sequence
            }
          />
        );

      default:
    }
  };

  const breadcrumbItems = [
    {
      label: "Audits Scheduled",
      path: "/audit-scheduled",
    },
    {
      label:
        "Edit Audit Plan" +
        (auditUpdatedata?.auditCode ? ` (${auditUpdatedata.auditCode})` : ""),
    },
  ];

  return (
    <CreateAudit
      Heading={"Edit Audit Plan"}
      auditUpdatedata={auditUpdatedata}
      loading={loading}
      setShowConfirm={setShowConfirm}
      renderStepContent={renderStepContent}
      steps={steps}
      nextStep={nextStep}
      prevStep={prevStep}
      currentStep={currentStep}
      handleSubmit={handleSubmit}
      nextDisable={nextDisable}
      submitClicked={submitClicked}
      showConfirm={showConfirm}
      showToast={showToast}
      aiSuggestion={aiSuggestion}
      showAISuggestion={showAISuggestion}
      setShowAISuggestion={setShowAISuggestion}
      setShowAIobservation={setShowAIobservation}
      showAItooltip={showAItooltip}
      setShowAItooltip={setShowAItooltip}
      AIloading={AIloading}
      setShowAICompanion={setShowAICompanion}
      showAICompanion={showAICompanion}
      userData={userData}
      aiContextHistory={aiContextHistory}
      breadcrumbItems={breadcrumbItems}
    />
  );
};

export default UpdateAuditPlanning;
